import { memo, useCallback } from 'react';
import { ROW } from '../../virtualization/types/observerTypes';
import { useObserveTableElementRef } from '../../virtualization/hooks/useObserveTableElementRef';
import { useIsRowVisible, useVisibleColumnsIfRowVisible } from '../../virtualization/VirtualizationContext';
import Cell from './Cell';
import SelectRowCheckboxCell from '../../selection/components/SelectRowCheckboxCell';
import { mergeRefs } from 'foundations-components/transitional/utils/mergeRefs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Row = ({
  rowId,
  rowIndex,
  row,
  columns,
  selectable,
  showSelectPlaceholder,
  RowComponent,
  numberOfFrozenColumns = 0,
  measureElement,
  virtualIndex
}) => {
  const handleObserveRef = useObserveTableElementRef();
  const isRowVisible = useIsRowVisible(rowIndex);
  const visibleColumns = useVisibleColumnsIfRowVisible(isRowVisible);
  const mergedRef = useCallback(node => mergeRefs([handleObserveRef, measureElement])(node), [handleObserveRef, measureElement]);
  const showSelectCell = selectable;
  const showSelectPlaceholderCell = !showSelectCell && showSelectPlaceholder;
  return /*#__PURE__*/_jsxs(RowComponent, {
    row: row,
    trRef: mergedRef,
    requiredRowProps: {
      'data-test-id': `row-${rowId}`,
      'data-observer-type': ROW,
      'data-observer-id': rowIndex,
      'data-index': virtualIndex
    },
    columns: columns,
    rowId: rowId,
    selectable: selectable,
    children: [showSelectCell && /*#__PURE__*/_jsx(SelectRowCheckboxCell, {
      rowId: rowId,
      rowIndex: rowIndex,
      numberOfFrozenColumns: numberOfFrozenColumns
    }), showSelectPlaceholderCell && /*#__PURE__*/_jsx("td", {
      "data-selection-column": true
    }), columns.map((column, columnIndex) => {
      const {
        CellComponent,
        columnNamespace,
        columnName
      } = column;
      const isCellVisible = virtualIndex === undefined ? isRowVisible && visibleColumns.has(columnIndex) : true;
      return /*#__PURE__*/_jsx(Cell, {
        columns: columns,
        columnIndex: columnIndex,
        rowIndex: rowIndex,
        columnNamespace: columnNamespace,
        columnName: columnName,
        CellComponent: CellComponent,
        rowId: rowId,
        row: row,
        selectable: selectable,
        isCellVisible: isCellVisible
      }, `${columnNamespace}-${columnName}-${rowId}`);
    })]
  });
};
export default /*#__PURE__*/memo(Row);